<template>
  <el-form ref="form" :model="form" :rules="rules" class="form__login" @submit.native.prevent="onSubmit">
    <!-- Company name -->
    <el-row :gutter="20">
      <el-col :xs="24">
        <el-form-item :label="$t('Company name')" prop="company_name">
          <el-input placeholder="Your Company GmbH" v-model="form.company_name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- Street and number -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Street and number')" prop="street_nr">
          <el-input placeholder="Hauptstrasse 1" v-model="form.street_nr"></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Zip')" prop="zip">
          <el-input placeholder="10115" v-model="form.zip"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- City and country -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('City')" prop="city">
          <el-input placeholder="Berlin" v-model="form.city"></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Country')" prop="country">
          <SelectCountry
            :options="countries"
            :placeholder="'Deutschland'"
            :selected="countries[0]"
            :loading="loadingCountries"
            @on-change="onChangeCountry"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <!-- Phone and web -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Phone')" prop="phone">
          <el-input placeholder="+49 030 123 456" v-model="form.phone"></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Web')" prop="web">
          <el-input placeholder="www.example.com" v-model="form.web"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <Separator class="m-t-2 m-b-2" :show-line="true" :text="$t('User data')"></Separator>

    <!-- First name, last name -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('First name')" prop="first_name">
          <el-input placeholder="Max" v-model="form.first_name"></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Last name')" prop="last_name">
          <el-input placeholder="Muster" v-model="form.last_name"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <!-- E-Mail and password -->
    <el-row :gutter="20">
      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Email')" prop="email">
          <el-input type="email" :placeholder="$t('Email')" v-model="form.email"></el-input>
        </el-form-item>
      </el-col>

      <el-col :xs="24" :sm="12">
        <el-form-item :label="$t('Password')" prop="password">
          <el-input type="password" :placeholder="$t('Password')" v-model="form.password"></el-input>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :xs="24">
        <el-form-item prop="accept_privacy_policy">
          <el-checkbox v-model="form.accept_privacy_policy" :true-label="1" :false-label="0">
            <span v-html="$t('I have read the privacy policy and accept them')"></span>
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>

    <el-form-item class="m-t-2 m-b-0">
      <el-button type="primary" native-type="submit" class="w-100" :loading="loading">{{ $t('Create new account') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { REGISTER_COMPLETE } from '@/router/route-types';
import { getCountries } from '@/services/country';
import { register } from '@/services/auth';
import { transformCountriesForSelect } from '@/shared/transformers';
import SelectCountry from '@/components/Select/Select';
import Separator from '@/components/Misc/Separator';
import { get } from 'lodash';

export default {
  name: 'FormRegister',

  components: {
    SelectCountry,
    Separator
  },

  data() {
    return {
      countries: [
        {
          label: 'Deutschland',
          value: 1
        }
      ],
      form: {
        accept_privacy_policy: null,
        first_name: '',
        last_name: '',
        title: '',
        email: '',
        password: '',
        company_name: '',
        street_nr: '',
        city: '',
        country: 1,
        zip: null,
        phone: '',
        web: ''
      },
      loading: false,
      loadingCountries: false,
      rules: {
        accept_privacy_policy: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'change'
          }
        ],
        first_name: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        last_name: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        company_name: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        street_nr: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        city: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        country: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        zip: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.$t('Please enter valid email address'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('Please fill out all required fields'),
            trigger: 'blur'
          }
        ]
      }
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.loadingCountries = true;
      getCountries()
        .then(response => {
          this.countries = transformCountriesForSelect(response.data);
          this.loadingCountries = false;
        })
        .catch(err => {
          this.loadingCountries = false;
        });
    },

    onChangeCountry(item) {
      this.form.country = item.id;
    },

    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doRegister();
        } else {
          return false;
        }
      });
    },

    doRegister() {
      console.log('doRegister', this.form);
      this.loading = true;

      register(this.form)
        .then(result => {
          this.loading = false;
          console.log('doRegister response', result);

          const errorMessage = get(result, 'message');

          // Incorrect authentification
          if (errorMessage) {
            this.$message({
              message: errorMessage,
              type: 'error',
              showClose: true,
              duration: 10000
            });

            return false;
          }

          // Redirect to main page
          this.$router.push({ name: REGISTER_COMPLETE });
        })
        .catch(err => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.separator {
  &__text {
    color: $c-gray;
    font-size: 1.2rem;
  }
}
</style>
